// The API this app talks to.
//
// Production is the default, so a plain `npm run build` is always correct even
// when the working tree has been pointed somewhere else for local work. To run
// against a backend on this machine, put this line in `.env.development.local`,
// which is gitignored and read only by `npm start`:
//
//   REACT_APP_BACKEND_URL=http://localhost:3001
//
// Deliberately not `.env.local`: that file is read by production builds too,
// which is exactly how a deploy ends up shipping a localhost API.
export const backendDomain =
  process.env.REACT_APP_BACKEND_URL || "https://auctionbackend.spectors.in";
